import { memo } from 'react'
import { Images } from '../../assets/scripts/Images'

function Logo({ user_device }) {
  const logo = user_device === 'desktop' ? Images.logo : Images.mini_logo
  const lightLogo = user_device === 'desktop' ? Images.lightLogo : Images.mini_light_logo
  const width = user_device === 'desktop' ? 130 : 70
  const height = user_device === 'desktop' ? 70 : 20

  return (
    <>
      <img
        src={lightLogo}
        alt="milani auto clinic"
        className={'sm:my-8 mx-auto hidden dark:block'}
        width={width}
        height={height}
      />
      <img
        src={logo}
        alt="milani auto clinic"
        className={'sm:my-8 mx-auto block dark:hidden'}
        width={width}
        height={height}
      />
    </>
  )
}

export default memo(Logo)
